import React from 'react';
import Header from '../Header';
import Footer from '../Footer';

type PageShellProps = {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
};

const PageShell: React.FC<PageShellProps> = ({ children, tone = 'dark' }) => (
  <div className={tone === 'dark' ? 'min-h-screen bg-[#06150e] text-white' : 'min-h-screen bg-[#f6f8f2] text-[#102016]'}>
    <Header />
    <main>{children}</main>
    <Footer />
  </div>
);

export default PageShell;
